import React from 'react'
import Switch from 'react-switch'
import '../component-styles/react-switch-overrides.scss'
import Row, { Slot } from './row'
import PointingHand from '../assets/hand-pointing.svg'
import styles from '../component-styles/annual-toggle.module.scss'
import preloadAnnual from '../assets/toggle-annual.svg'
import preloadMonthly from '../assets/toggle-monthly.svg'

interface Props {
  checked?: boolean
  onChange: (e: boolean) => void
}

export default function ToggleButton({
  checked,
  onChange,
}: Props): React.ReactElement {
  return (
    <>
      <img src={preloadAnnual} className="preload-image" alt="annual" />
      <img src={preloadMonthly} className="preload-image" alt="monthly" />
      <Row align="center">
        <Slot align="flex-end" width={166} className={styles.button}>
          <div className={`annual-toggle ${!checked ? 'active' : ''}`}>
            <Switch
              onChange={(): void => onChange(!checked)}
              checked={!checked}
              checkedIcon={false}
              uncheckedIcon={false}
              className="toggle-container"
            />
          </div>
        </Slot>
        <Slot align="center" width={30} className={styles.hideAtMobile}>
          <img src={PointingHand} alt="click annual" />
        </Slot>
        <Slot align="flex-start" width={310} className={styles.copy}>
          <p style={{ paddingLeft: 6, fontWeight: 700 }}>
            Choose ANNUAL for 20% off!
          </p>
        </Slot>
      </Row>
    </>
  )
}
